/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './auth-footer.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../app/auth/auth-footer/auth-footer.component';
import * as i5 from '../../../../app/core/app-memory.service';
const styles_AuthFooterComponent:any[] = [i0.styles];
export const RenderType_AuthFooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AuthFooterComponent,data:{}});
export function View_AuthFooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'footer',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      2,'div',[['class','copy']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(3,(null as any),['\n    © ',' Equine MediRecord.\n    ',
      '\n  '])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(_ck,_v) => {
        var _co:i4.AuthFooterComponent = _v.component;
        const currVal_0:any = _co.appMemory.year;
        const currVal_1:any = i1.ɵunv(_v,3,1,i1.ɵnov(_v,4).transform('CONTACTS.allRightReserved'));
        _ck(_v,3,0,currVal_0,currVal_1);
      });
}
export function View_AuthFooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-auth-footer',
      ([] as any[]),(null as any),(null as any),(null as any),View_AuthFooterComponent_0,
      RenderType_AuthFooterComponent)),i1.ɵdid(1,114688,(null as any),0,i4.AuthFooterComponent,
      [i5.AppMemoryService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AuthFooterComponentNgFactory:i1.ComponentFactory<i4.AuthFooterComponent> = i1.ɵccf('app-auth-footer',
    i4.AuthFooterComponent,View_AuthFooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS92c3RzL3dvcmsvMS9zL2Vtci13ZWJhcHAvc3JjL2FwcC9hdXRoL2F1dGgtZm9vdGVyL2F1dGgtZm9vdGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXV0aC9hdXRoLWZvb3Rlci9hdXRoLWZvb3Rlci5jb21wb25lbnQudHMuQXV0aEZvb3RlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxmb290ZXI+XG4gIDxkaXYgY2xhc3M9XCJjb3B5XCI+XG4gICAgwqkge3sgdGhpcy5hcHBNZW1vcnkueWVhciB9fSBFcXVpbmUgTWVkaVJlY29yZC5cbiAgICB7eyBcIkNPTlRBQ1RTLmFsbFJpZ2h0UmVzZXJ2ZWRcIiB8IHRyYW5zbGF0ZSB9fVxuICA8L2Rpdj5cbjwvZm9vdGVyPlxuIiwiPGFwcC1hdXRoLWZvb3Rlcj48L2FwcC1hdXRoLWZvb3Rlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBUTthQUFBLDZCQUNOO01BQUE7TUFBQSxnQkFBa0I7TUFBQTtNQUdaLDBDQUNDOzs7UUFKVztRQUFBO1FBQUE7Ozs7b0JDRHBCO01BQUE7b0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/auth/auth-footer/auth-footer.component.ngfactory.ts